import {
  vArray,
  vBoolean,
  vNonEmptyString,
  vNumber,
  vObject,
  vObjectId,
  vOptional,
  vOptionalDef,
  type vOutput,
  vPicklist,
  vString,
} from '../validation/index.ts'

export const saveQuoteSchema = vObject({
  quoteId: vObjectId(),
  refNum: vOptional(vNonEmptyString()),
})

export type SaveQuoteDTO = vOutput<typeof saveQuoteSchema>

export const findSavedQuotesSchema = vObject({
  search: vOptional(vString()),
  awarded: vOptionalDef(vBoolean(), false),
  quotedBy: vOptional(vArray(vObjectId())),
  sortDirection: vOptional(vPicklist([1, -1])),
  skip: vOptionalDef(vNumber(), 0),
  limit: vOptionalDef(vNumber(), 50),
  continuationToken: vOptional(vString()),
})

export type FindSavedQuotesDTO = vOutput<typeof findSavedQuotesSchema>
